import { render, staticRenderFns } from "./ProductsListViewLH.vue?vue&type=template&id=8bfe7926&scoped=true"
import script from "./ProductsListViewLH.vue?vue&type=script&lang=js"
export * from "./ProductsListViewLH.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfe7926",
  null
  
)

export default component.exports